import { render, staticRenderFns } from "./ModuleSearch.vue?vue&type=template&id=6b4c2022&scoped=true&lang=pug&"
import script from "./ModuleSearch.vue?vue&type=script&lang=js&"
export * from "./ModuleSearch.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSearch.vue?vue&type=style&index=0&id=6b4c2022&lang=scss&scoped=true&"
import style1 from "./ModuleSearch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c2022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VTextField})
